import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getdistributorlist,
  searchdistributorlist,
  getmaster,
  getsortlistdistributor,
} from "../../actions/assetAction";
import { distributorlist } from "../../actions/userListAction";
import { distributor_export } from "../../actions/exportAction";
import _ from "lodash";
import { Button, Table, Tag, Form, Select, Input, message } from "antd";
const { Option } = Select;
class Distributors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      distributor: [],
      dislist: [],
      pagination: {},
      loading: true,
      loadingbtn: false,
      loadingEPbtn: false,
      visible: false,
      selectedItems: [],
      selectedfieldname: [],
      selectedfilter: [],
      sort_list: [],
    };
  }

  componentWillMount() {
    this.props
      .getsortlistdistributor()
      .then((res) => {
        console.log(res.data);
        this.setState({
          sort_list: res.data,
        });
      })
      .catch((err) => {
        this.setState({
          sort_list: [],
        });
      });
    this.getdesignation({
      results: 10,
      page: 1,
    });
    this.props.getmaster().then((res) => {
      this.setState({
        master: this.props.data.master,
      });
    });
  }
  getdesignation(params = {}) {
    this.setState({ loading: true });
    this.props
      .getdistributorlist(params)
      .then((res) => {
        console.log(res);
        const pagination = { ...this.state.pagination };
        pagination.total = res.data.items.total;
        pagination.current = res.data.items.current_page;
        this.setState({
          distributor: res.data.items.data,
          loading: false,
          pagination,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }
  handleTableChange = (pagination, filter, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    var status = filter?.status ?? [];
    this.setState({
      pagination: pager,
      selectedstatus: status.toString(),
      sortField: sorter.order === undefined ? "" : sorter.field,
      sortOrder:
        sorter.order === "ascend"
          ? "ASC"
          : sorter.order === undefined
          ? ""
          : "DESC",
    });
    setTimeout(() => {
      this.searchDistributor();
    }, 100);
  };
  fetch = (params = {}) => {
    console.log("params:", params);
    this.getdesignation(params);
  };
  showDrawer = (res) => {
    console.log(res);
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  getrefreshbtn = () => {
    this.clearSearch();
    this.getdesignation({
      results: 10,
      page: 1,
    });
  };
  getexportbtn = () => {
    this.setState({ loading: true, loadingEPbtn: true });
    var search_text = this.state.name;
    var master_agent = this.state.selectedItems;
    var status = this.state.selectedstatus;
    this.props
      .distributor_export({
        search_text: search_text,
        master_agent: master_agent,
        status:status
      })
      .then((res) => {
        this.setState({ loading: false, loadingEPbtn: false });
        if (res.data.download === 0) {
          message.success(res.data.message);
        } else {
          window.open(res.data.url, "_blank");
        }
      })
      .catch((err) => {
        this.setState({ loading: false, loadingEPbtn: false });
      });
  };
  // ======================================================
  renderMaster() {
    return _.map(this.state.master, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }

  searchDistributor = (reset) => {
    console.log(reset);
    this.setState({
      loading: true,
      loadingbtn: true,
    });
    var status = this.state.selectedstatus;
    var search_text = this.state.name;
    var master_agent = this.state.selectedItems;
    var page = reset ? 1 : this.state.pagination?.current ?? 1;
    var sort = this.state.sortField;
    var sort_by = this.state.sortOrder;

    console.log("sort data", sort);
    this.props
      .searchdistributorlist({
        status: status,
        search_text: search_text,
        master_agent: master_agent,
        page: page,
        sort,
        sort_by,
      })
      .then((res) => {
        console.log(res);
        const pagination = { ...this.state.pagination };
        pagination.total = res.data.items.total;
        pagination.current = res.data.items.current_page;
        this.setState({
          distributor: res.data.items.data,
          loading: false,
          loadingbtn: false,
          pagination,
        });
      })
      .catch((err) => {
        this.setState({ loadingbtn: false });
      });
  };

  clearSearch = () => {
    this.setState({
      status: undefined,
      name: "",
      agent: "",
      selectedItems: [],
      selectedfieldname: [],
      selectedfilter: [],
    });
    this.getdesignation({
      results: 10,
      page: 1,
    });
  };

  onchangeRole = (selectedItems) => {
    this.setState({ selectedItems });
    console.log(this.state.selectedItems);
  };
  onchangefieldname = (selectedfieldname) => {
    this.setState({ selectedfieldname });
    console.log(this.state.selectedfieldname);
  };
  onchangefilter = (selectedfilter) => {
    this.setState({ selectedfilter });
    console.log(this.state.selectedfilter);
  };
  renderSorter() {
    return _.map(this.state.sort_list, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  render() {
    const { distributor } = this.state;

    const columns = [
      {
        title: "Master",
        dataIndex: "master_agent_name",
        key: "master_agent_name",
        sorter: true,
      },
      {
        title: "Distributor",
        dataIndex: "name",
        key: "name",
        sorter: true,
      },
      {
        title: "User",
        dataIndex: "get_manager_info",
        key: "get_manager_info",
        sorter: true,
        render: (tags) => (
          <span>
            {tags.map((tag) => {
              return (
                <Tag color="volcano" key={tag}>
                  {tag.name}
                </Tag>
              );
            })}
          </span>
        ),
      },

      {
        title: "Created Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
      },

      {
        title: "Status",
        key: "status",
        dataIndex: "status",
        filters: [
          { text: "Active", value: 1 },
          { text: "Inactive", value: 0 },
        ],
        render: (tag) => (
          <span>
            <Tag color={tag === 1 ? "green" : "orange"}>
              {tag ? "Active" : "Inactive"}
            </Tag>
          </span>
        ),
      },
      // {
      //   title: "Action",
      //   key: "action",
      //   width: 100,
      //   render: (text, record) => (
      //     <span>
      //       <Button type="link" onClick={() => this.showDrawer(record)}>
      //         Edit
      //       </Button>
      //     </span>
      //   ),
      // },
    ];
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <div className="container-fluid">
          <div className="row padd20 bg-grey">
            <div className="col-sm-4">
              <h4>
                Distributors{" "}
                {this.state.pagination.total &&
                  `(${this.state.pagination.total})`}
              </h4>
            </div>
            <div className="col-sm-8 text-right">
              {/* {this.rendercsvformat(data)} */}
              <Button
                type="primary"
                className="mr5"
                loading={this.state.loadingEPbtn}
                onClick={() => this.getexportbtn()}
              >
                <i className="uil uil-export" /> Export Report
              </Button>
              <Button
                type="default"
                className="mr5"
                onClick={() => this.getrefreshbtn()}
              >
                <i className="uil uil-sync" /> Refresh
              </Button>
              {/* {userpermission.Create ? (
                <Link to="/addmarketer">
                  <Button type="primary">Add IBO/Market</Button>
                </Link>
              ) : null} */}
            </div>
          </div>
          <div
            className="row padd20 bg-grey "
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <div className="col">
              <Select
                placeholder="Select Status"
                style={{ width: "100%" }}
                value={
                  this.state.status !== undefined && this.state.status !== null
                    ? this.state.status === 1
                      ? "Active"
                      : "Inactive"
                    : undefined
                }
                onChange={(value) =>
                  this.setState({
                    status: value === "Active" ? 1 : 0,
                  })
                }
              >
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </div> */}
            <div className="col-3">
              <label for="exampleFormControlInput1">Search Master Agent</label>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Option"
                value={this.state.selectedItems}
                onChange={this.onchangeRole}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {this.renderMaster()}
              </Select>
            </div>

            <div className="col-3">
              <label for="exampleFormControlInput1">Search By Keyword</label>
              <Input
                placeholder="Type Keyword"
                value={this.state.name}
                onChange={(e) =>
                  this.setState({
                    name: e.target.value,
                  })
                }
                style={{ width: "100%", display: "block" }}
              />
            </div>
            <div className="col-4 mt-6 ">
              <Button
                type="primary"
                className="mr5"
                loading={this.state.loadingbtn}
                onClick={() => this.searchDistributor()}
              >
                Search
              </Button>
              <Button type="default" onClick={() => this.clearSearch()}>
                Clear
              </Button>
            </div>
          </div>
          <div className="bg-white padd0">
            <Table
              columns={columns}
              dataSource={distributor}
              scroll={{ x: true }}
              pagination={this.state.pagination}
              loading={this.state.loading}
              onChange={this.handleTableChange}
              // size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    userinfo: state.userinfo,
    data: state.data,
  };
}

const App = Form.create()(Distributors);

export default connect(mapStateToProps, {
  getdistributorlist,
  distributorlist,
  searchdistributorlist,
  getmaster,
  getsortlistdistributor,
  distributor_export,
})(App);
